import { runWhenDomLoaded } from '@frontend/utils/dom';

import CampaignTracking from '@frontend/app/features/CampaignTracking';
import ConvertedWithTracking from '@frontend/app/features/ConvertedWithTracking';
import SteadyCheckoutWidget from '@frontend/app/features/SteadyCheckoutWidget';

window.top.KRWebflowEnv = window.top.KRWebflowEnv || {};
window.top.KRWebflowEnv.steadyUtmCampaignParam =
  SteadyCheckoutWidget.generateUtmCampaignTracking();

runWhenDomLoaded(() => {
  CampaignTracking.init();
  ConvertedWithTracking.init();
});
